import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AnimatedWrapper from "../components/AnimatedWrapper";
import amplitude from "../utils/amplitude";

export default function Page6() {
  const navigate = useNavigate();

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
        if(process.env.NODE_ENV === "production"){
              amplitude.track('Quiz Step Open', {
            step_number: 6,
          });
            }
    setVH();
    window.addEventListener("resize", setVH);
    return () => window.removeEventListener("resize", setVH);
  }, []);

  const nextStep = () => {
    if(process.env.NODE_ENV === "production"){
      amplitude.track("Quiz Step Complete", {
        step_number: 6,
        answers: "",
      });

    }
    navigate("/quiz7");
  };

  return (
    <AnimatedWrapper>
      <div
        className="flex flex-col px-4 text-center"
        style={{ height: "calc(var(--vh, 1vh) * 100)" }}
      >
        {/* Контент сверху (убрал justify-center) */}
        <div className="flex flex-col items-center flex-grow">
          <h1 className="text-lg sm:text-xl font-semibold mb-4">
            You're in good hands
          </h1>

          {/* Фото в круге */}
          <div className="relative w-64 h-64 my-4">
            <div
              className="absolute inset-0 rounded-full p-6 transform scale-105"
              style={{ border: "3px solid #FC5EB2" }}
            >
              <div className="w-full h-full rounded-full p-2 overflow-hidden">
                <img
                  src="/img6.png"
                  alt="Skincare"
                  className="object-cover w-full h-full rounded-full"
                />
              </div>
            </div>
          </div>

          <h2 className="text-lg sm:text-xl font-semibold mt-6 leading-snug">
            You are not alone!
            <br />
            Solvi has helped 25,894
            <br />
            people with similar concerns
          </h2>
        </div>

        {/* Кнопка Next прижата к низу */}
        <div className="mt-auto mb-4">
          <button
            className="w-full py-4 rounded-full bg-pinkCustom text-white font-semibold hover:bg-pinkCustom transition"
            onClick={nextStep}
          >
            Next
          </button>
        </div>
      </div>
    </AnimatedWrapper>
  );
}
